module.exports = __webpack_public_path__ + "img/image_9.bcfa44ce.jpg";